class OnScroll {
    constructor() {
        this._init()
    }
    _init() {
        this.els = document.querySelectorAll('[data-on-scroll]')
        if(!this.els) {
            return
        }
        window.addEventListener('scroll', () => this.onScroll())
        this.onScroll()
    }
    onScroll() {
        const scrolled = Math.min(window.scrollY / 50, 1)
        const isScrolled = Math.floor(scrolled);
       
        const root = document.documentElement.style
        root.setProperty('--scrolled', scrolled)
        root.setProperty('--is-scrolled', isScrolled)

        if(window.scrollY > 0) {
            this.els.forEach(el => {
                el.classList.add("user-is-scrolling")
            })
        } else {
            this.els.forEach(el => {
                el.classList.remove("user-is-scrolling")
            })
        }
    }
}

export default OnScroll